import React, { FC, useContext } from 'react';

import { LucidTheme, mqMin, Products } from '@lucid/theme';

import AlertBanner from '../alert/alert-banner';
import Container from '../../container/container';
import LayoutContext from '../../context/layout-context';
import { LinkProps } from '../../link/link';

type Announcement = {
  linkText?: string;
  linkUrl?: string;
  storageKey?: string;
  content?: string;
};

export interface AnnouncementBannerProps {
  /** The specific site. */
  product: Products | 'test';
}

const AnnouncementBanner: FC<AnnouncementBannerProps> = ({ product }) => {
  const {
    language: { langPrefix },
    location: { pathname },
  } = useContext(LayoutContext);

  const announcements: Partial<Record<Products | 'default' | 'test', Announcement>> = {
    test: {
      linkText: 'Test link url',
      linkUrl: 'https://lucid.co/careers',
      storageKey: 'test-announcement-key',
      content: 'Test announcement banner text!',
    },
    default: {
      linkText: undefined,
      linkUrl: undefined,
      storageKey: undefined,
      content: undefined,
    },
    chart: {
      linkText: undefined,
      linkUrl: undefined,
      storageKey: undefined,
      content: undefined,
    },
  };
  const announcement = announcements[product] || announcements.default || null;

  // Lots of checks to see if we are good to render the banner or not.
  if (
    !announcement ||
    langPrefix !== 'en' ||
    pathname.includes('/landing') ||
    !announcement.content ||
    !announcement.linkText ||
    !announcement.linkUrl ||
    !announcement.storageKey
  ) {
    return null;
  }

  const { linkText, linkUrl, storageKey, content } = announcement;

  const linkProps: LinkProps = {
    hasArrow: true,
    underline: 'none',
    label: linkText,
    to: linkUrl,
  };

  return (
    <Container
      css={(theme: LucidTheme) => ({
        padding: 0,
        [mqMin.tablet]: {
          paddingTop: theme.space.s16,
          paddingBottom: theme.space.s8,
          '&:empty': {
            padding: 0,
          },
        },
      })}
    >
      <AlertBanner
        linkProps={linkProps}
        storageKey={storageKey!}
        storageType="local"
        variant="announcement"
        willDismissOnLinkClick={false}
      >
        {content}
      </AlertBanner>
    </Container>
  );
};

export { AnnouncementBanner };
export default AnnouncementBanner;
